import { useFeaturedServices } from '../../hooks/useServices';
import { ServiceCard } from '../service/ServiceCard';
import { Spinner } from '../ui/Card';
import { Link } from 'react-router-dom';
import { Button } from '../ui/Button';

export function ServicesGrid() {
  const { services, isLoading } = useFeaturedServices();

  return (
    <section className="bg-paper py-16">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="text-center">
          <p className="font-mono text-xs uppercase tracking-widest text-ledger-green">What we handle</p>
          <h2 className="mt-2 font-display text-3xl font-bold text-ink">Popular Services</h2>
        </div>

        {isLoading ? (
          <div className="mt-12 flex justify-center">
            <Spinner className="h-8 w-8 text-seal-blue" />
          </div>
        ) : (
          <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {services.map((service) => (
              <ServiceCard key={service.id} service={service} />
            ))}
          </div>
        )}

        <div className="mt-10 text-center">
          <Link to="/services">
            <Button variant="outline">View All Services</Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
